import { DecoratorType } from '../../../../types/types';

/**
 * Normalize a decorator value for rendering.
 * Returns undefined when the control has no decorator (null/undefined), so
 * callers can short-circuit with a truthiness check. Everything else is
 * coerced to string — `false` and `0` are preserved as visible text.
 */
export const resolveDecorator = (
  decorator: DecoratorType | undefined
): string | undefined => {
  if (decorator === null || decorator === undefined) {
    return undefined;
  }
  return String(decorator);
};
